module.exports = __webpack_public_path__ + "static/img/gzh_code.b415c1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzh_code.png
// module id = K9Kj
// module chunks = 1